<div class="graphic-block">
	<ng-container *ngFor="let roundel of sortedRoundels; let i = index; trackBy: trackByRoundelUrl">
		<img *ngIf="roundel.url" [src]="roundel.url" [alt]="roundel.altText" />
	</ng-container>
</div>
<section class="text-content">
	<div class="text-block">
		<h1
			[ngStyle]="{ color: item.colourTheme?.mainHeadingTextColor }"
			i18n="@@HeroItem-main-heading"
			[attr.aria-label]="item.mainHeadlineText"
			class="heading"
		>
			{{ item.mainHeadlineText }}
		</h1>
	</div>
	<div class="cta-block">
		<a
			[tabindex]="tabindex"
			*ngIf="item.tcLink"
			maybeExternal
			[maybeExternalCurrentTab]="false"
			[href]="item.tcLink"
			class="tc-link"
			[ngStyle]="{ color: item.colourTheme?.tcTextColor }"
			[attr.aria-label]="item?.tcAriaLabel"
			(click)="onTcLinkClick()"
		>
			<span> {{ item.tcLabel }} </span>
			<cdx-svg-icon
				*ngIf="isURLExternal(item.tcLink)"
				name="external-link"
				size="extra-small"
				display="inline"
				fill="currentColor"
			></cdx-svg-icon>
		</a>
		<a
			[tabindex]="tabindex"
			class="hero-button"
			cdxButton
			maybeExternal
			[maybeExternalCurrentTab]="true"
			[href]="item.buttonHref ?? ''"
			[fillStyle]="item.colourTheme?.buttonFillStyle"
			aria-live="polite"
			[attr.aria-label]="item.buttonAriaLabel"
			i18n="@@HeroItemButton-{{item.buttonLabel}}"
			(click)="onClickCtaBtn()"
		>
			{{ item.buttonLabel }}
		</a>
	</div>
</section>
